import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex gap-2 mb-1" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, " > ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { key: 2 }

import { ref } from "vue";
import type { Tol2008TreeDto } from "@api/tol2008-tree-dto";
import { getEntityTranslation } from "@/helpers";
import { watch } from "vue";
import publicFormApi from "@/publicFormApi";
import { onMounted } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'Tol2008PickerList',
  emits: ["pick"],
  setup(__props, { emit: __emit }) {

const loading = ref(false as boolean);
const topLevelTols = ref([] as Tol2008TreeDto[]);
const selectedTolList = ref([] as Tol2008TreeDto[]);
const selectedTopLevel = ref(null as null | Tol2008TreeDto);
const codeSearch = ref("" as string);
const nameSearch = ref("" as string);
const emit = __emit;

onMounted(() => {
	getTopLevelTols();
});
const getTopLevelTols = async () => {
	loading.value = true;
	const resp = await publicFormApi.call.form.get.tol2008TopLevel();
	if (resp.isSuccessful && resp.data) {
		topLevelTols.value = resp.data;
	}
	loading.value = false;
};
const backToTopLevel = () => {
	selectedTopLevel.value = null;
	codeSearch.value = "";
	nameSearch.value = "";
};
const pickTol = (tol: Tol2008TreeDto) => {
	backToTopLevel();
	emit("pick", tol);
};
const searchTol2008ByCode = async (search: string) => {
	if (search.length == 0) {
		backToTopLevel();
		return;
	}
	nameSearch.value = "";
	loading.value = true;
	const resp = await publicFormApi.call.form.get.searchTol2008ByCode(search);
	if (resp.isSuccessful && resp.data) {
		selectedTolList.value = resp.data;
	}
	loading.value = false;
};
const searchTol2008ByName = async (search: string) => {
	if (search.length == 0) {
		backToTopLevel();
		return;
	}
	if (search.length < 3) return; //short-circuit
	codeSearch.value = "";
	loading.value = true;
	const resp = await publicFormApi.call.form.get.searchTol2008ByName(search);
	if (resp.isSuccessful && resp.data) {
		selectedTolList.value = resp.data;
	}
	loading.value = false;
};
const searchTol2008ByRootCode = (search: string) => {
	loading.value = true;
	selectedTolList.value = [];
	publicFormApi.call.form.get
		.tol2008ByRootCode(search)
		.then((r) => {
			if (r.isSuccessful && r.data) {
				selectedTolList.value = r.data;
			}
		})
		.finally(() => (loading.value = false));
};

watch(selectedTopLevel, (newval) => {
	if (newval) {
		searchTol2008ByRootCode(newval.code);
	}
});

return (_ctx: any,_cache: any) => {
  const _component_HakoInput = _resolveComponent("HakoInput")!
  const _component_HakoSpinner = _resolveComponent("HakoSpinner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_HakoInput, {
        placeholder: "Hae koodilla",
        modelValue: codeSearch.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((codeSearch).value = $event)),
        onDebounce: _cache[1] || (_cache[1] = ($event: any) => (searchTol2008ByCode(codeSearch.value)))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_HakoInput, {
        placeholder: "Hae nimellä",
        modelValue: nameSearch.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((nameSearch).value = $event)),
        onDebounce: _cache[3] || (_cache[3] = ($event: any) => (searchTol2008ByName(nameSearch.value)))
      }, null, 8, ["modelValue"])
    ]),
    (!selectedTopLevel.value && codeSearch.value.length == 0 && nameSearch.value.length == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(topLevelTols.value, (topTol) => {
            return (_openBlock(), _createElementBlock("div", {
              key: topTol.code
            }, [
              _createElementVNode("a", {
                onClick: _withModifiers(($event: any) => (selectedTopLevel.value = topTol), ["prevent"]),
                href: "#"
              }, _toDisplayString(topTol.code) + " " + _toDisplayString(_unref(getEntityTranslation)(topTol.translations, "name")), 9, _hoisted_3)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (selectedTopLevel.value || codeSearch.value.length > 0 || nameSearch.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (selectedTopLevel.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("a", {
                  href: "#",
                  onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (backToTopLevel()), ["prevent"]))
                }, "Päätasot"),
                _hoisted_6,
                _createTextVNode(" " + _toDisplayString(_unref(getEntityTranslation)(selectedTopLevel.value.translations, "name")), 1)
              ]))
            : _createCommentVNode("", true),
          _hoisted_7,
          (loading.value)
            ? (_openBlock(), _createBlock(_component_HakoSpinner, { key: 1 }))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedTolList.value, (tol2008) => {
            return (_openBlock(), _createElementBlock("div", {
              key: tol2008.code
            }, [
              _createElementVNode("a", {
                href: "#",
                onClick: _withModifiers(($event: any) => (pickTol(tol2008)), ["prevent"])
              }, _toDisplayString(tol2008.rootCode) + " " + _toDisplayString(tol2008.code) + " " + _toDisplayString(_unref(getEntityTranslation)(tol2008.translations, "name")), 9, _hoisted_8)
            ]))
          }), 128)),
          (selectedTolList.value.length === 0 && !loading.value)
            ? (_openBlock(), _createElementBlock("i", _hoisted_9, _toDisplayString(_ctx.$t("generic.noSearchResults")), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})